import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from 'react-redux';
import { useRef, useCallback } from 'react';
import { debounce } from 'lodash';
import { setSearchString } from '../../../../../app/engagement/actions';
import styles from './styles.module.scss';
import { SearchInput } from '../../../../infra/ui/search-input';
import { useReduxSelector } from '../../../../infra/redux-bridge';
import { EngageTracker } from '../../tracking';
import { ENGAGE_CAMPAIGNS_LIST_SEARCHED } from '../../tracking/events';
import { t } from '../../../../infra/i18n';
export var CampaignSearchInput = function () {
    var store = useStore();
    var initialValue = useReduxSelector('engagement.searchString');
    var totalCampaigns = useReduxSelector('engagement.campaigns.totalCount') || 0;
    var trackSearch = useRef(debounce(function () {
        EngageTracker.getInstance().track(ENGAGE_CAMPAIGNS_LIST_SEARCHED, {
            resultsCount: totalCampaigns,
            searchType: 'instant',
        });
    }, 500));
    var setCampaignFilter = useCallback(function (value) {
        store.dispatch(setSearchString(value));
        if (value) {
            trackSearch.current();
        }
    }, [store, trackSearch]);
    return (_jsx("div", { className: styles['search-container'], children: _jsx("div", { className: "c-search-input", children: _jsx(SearchInput, { className: "c-search-input-component", name: "campaign-list-search-input", placeholder: t('engage:search_placeholder'), showIcon: true, setSearchTerm: setCampaignFilter, initialValue: initialValue }) }) }));
};
